import { DataSource, Layout, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutCarrierOverride extends Layout {
    sourceMovement: DataSource;
    textboxMovementId: Textbox;
    textboxOrderId: Textbox;
}
